import React from "react";
import CalculatorsList from "../../../components/CalculatorsList";

const sheetsList = [
    {title: 'Żelbet',
        sheets: [
            {name: 'Otulina', path: '/otulina'},
            {name: 'Zakład, zakotwienie'},
            {name: 'Krótki wspornik'},
            {name: 'Zginanie'}
        ]
    },
    {title: 'Stal',
        sheets: []
    }
];

class HomePage extends React.Component {

    render() {
        return (
            <div>
                <CalculatorsList sheetsBoxes={sheetsList}/>
            </div>
        )
    }
}

export default HomePage;